export default __webpack_public_path__ + "static/Newsletter_background_image_people_desktop-3dda4a9daa11652943ca88104637f61b.png";